import { useEffect } from 'react'
import ReportSection from 'ui/clinicianScreens/Patient/Report/components/ReportSection'
import {
  formatAverage,
  formatDiff,
} from 'ui/clinicianScreens/Patient/Report/helpers'
import {
  defaultAverage,
  getAverageDiff,
} from 'ui/clinicianScreens/Patient/Report/sections/TremorAndDyskinesia/helpers'
import { SECTION_TITLES } from 'ui/clinicianScreens/Patient/Report/consts'
import ReportChartDyskinesia from 'ui/clinicianScreens/Patient/Report/sections/TremorAndDyskinesia/Dyskinesia/ReportChartDyskinesia'
import { useSectionTitle } from 'ui/clinicianScreens/Patient/Report/sectionTitles'
import { Text } from 'ui/baseComponents'
import { useReportTranslation } from 'utilities/i18n'

const DyskinesiaHelper = ({ t, isClinicianReport }) => (
  <Text variant="body14" component="p" data-cy="dyskinesia-helper">
    <strong>
      {isClinicianReport
        ? t('report.dyskinesia.aboutTheData')
        : t('report.dyskinesia.aboutYourData')}
    </strong>{' '}
    {isClinicianReport
      ? t('report.dyskinesia.clinician')
      : t('report.dyskinesia.patient')}
  </Text>
)

const ReportSectionDyskinesia = ({
  onLoadStart = () => {},
  onLoadEnd = () => {},
  hiddenSections,
  addToHasDataSet,
  removeFromHasDataSet,
  isClinicianReport,
  hasDataSet,
  data,
  prevData,
  loading,
}) => {
  const title = SECTION_TITLES.DYSKINESIA
  const sectionTitle = useSectionTitle()
  const { t } = useReportTranslation()

  useEffect(() => {
    if (loading) {
      onLoadStart(title)
    } else {
      onLoadEnd(title)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  let dyskinesiaAverage = { ...defaultAverage }

  let prevDyskinesiaAverage = { ...defaultAverage }

  if (data) {
    dyskinesiaAverage = formatAverage(data)
  }

  if (prevData) {
    prevDyskinesiaAverage = formatAverage(prevData)
  }

  const dyskinesiaAverageDiff = getAverageDiff(
    dyskinesiaAverage,
    prevDyskinesiaAverage,
  )
  const hasDyskinesiaData = data?.numberOfDaysWithData > 0

  useEffect(() => {
    hasDyskinesiaData ? addToHasDataSet(title) : removeFromHasDataSet(title)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasDyskinesiaData])

  return (
    <ReportSection
      {...{
        hidden:
          hiddenSections.has(title) ||
          (isClinicianReport && !hasDataSet.has(title)),
        noBorder: true,
      }}
    >
      <ReportChartDyskinesia
        {...{
          currentData: data,
          prevData,
          onLoadStart,
          onLoadEnd,
          diff: formatDiff(t, dyskinesiaAverageDiff),
          displayTitle: sectionTitle(title),
        }}
      />
      {hasDyskinesiaData && (
        <DyskinesiaHelper t={t} isClinicianReport={isClinicianReport} />
      )}
    </ReportSection>
  )
}

export default ReportSectionDyskinesia
